import { CatIconDealer } from 'blocks-nextjs/blocks-react/components/Icons/Dealer';
import { CatIconLock } from 'blocks-nextjs/blocks-react/components/Icons/Lock';
import { CatIconPeople } from 'blocks-nextjs/blocks-react/components/Icons/People';


export const LIST_TYPES_DISPLAY = {
  private: {
    key: 'REQUISITIONLIST_TYPE_PRIVATE',
    icon: <CatIconLock data-testid={'cat-icon-lock'} />
  },
  shared: {
    key: 'PUBLIC',
    icon: <CatIconPeople data-testid={'cat-icon-people'} />
  },
  dealer: {
    key: 'REQUISITIONLIST_TYPE_DEALER',
    icon: <CatIconDealer data-testid={'cat-icon-dealer'} />
  }
};

export type TableDataProps = {
  [key: string]:
    | object[]
    | string
    | number
    | (() => void)
    | null
    | object
    | string[]
    | boolean
    | React.JSX.Element;
};

export type TableMeta = {
  behavior: 'filter' | 'sortable';
  width: string;
  isFrozen: boolean;
  align: 'right' | 'center';
  enableMobileView: boolean;
  sort: 'descending' | 'ascending'
};
